// create a class that will inherit from View
class SearchView {
  _parentElement = document.querySelector('.search');

  getQuery() {
    const query = this._parentElement.querySelector('.search__field').value;
    this._clearInput();
    return query;
  }

  _clearInput() {
    this._parentElement.querySelector('.search__field').value = '';
  }

  addHandlerSearch(handler) {
    this._parentElement.addEventListener('submit', function (e) {
      e.preventDefault();
      // this handler function is the controlSearchResults function!
      handler();
    });
  }
}
// don't export this class, but an instance (object) that was created by this class
export default new SearchView();
